import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  const data = fetchData;
  const formattedData = useMemo(() => {
    const rows = [];

    if (fetchData && Array.isArray(data)) {
      data.forEach((customer) => {
        const company = customer.Company || {};
        let orders = [];
        customer.Orders.forEach((order, index) => {
          // Consolidate all related order items into one list
          const allOrderItems = [
            ...(order.Order_sells || []),
            ...(order.order_borrows || []),
            ...(order.order_pawns || []),
            ...(order.Order_items || []),
          ];

          const formattedItems = allOrderItems.map((item) => {
            return {
              id: item.id || "",
              lenting_amount:
                item.lenting_amount ||
                item.selling_amount ||
                item.pawn_amount ||
                0,
              total_amount: item.total_price || item.pawn_price || 0,
              product_price: item.price || 0,
              total_price: item.total_price || item.pawn_price || 0,
              status: item.status || item.status_id || "",
              return_date: item.return_date
                ? moment(item.return_date).format(
                    "DD/MM/YYYY\n เวลา HH:mm:ss น."
                  )
                : "",
              created_date: item.created_date
                ? moment(item.created_date).format(
                    "DD/MM/YYYY\n เวลา HH:mm:ss น."
                  )
                : "",
              product_id: item.product_id || "",
              product_name: "", // Add this if available in your data
              product_code: "", // Add this if available in your data
              category_id: "", // Add this if available in your data
              product_code_com: "", // Add this if available in your data
              product_type: "",
              pictures: [], // Add this if available in your data
            };
          });
          // Calculate totals and other aggregated fields
          const total_price = formattedItems.reduce(
            (sum, item) => sum + parseFloat(item.total_price || 0),
            0
          );
          const lenting_amount = formattedItems.reduce(
            (sum, item) => sum + parseFloat(item.lenting_amount || 0),
            0
          );
          const return_date =
            formattedItems.length > 0 && formattedItems[0].return_date
              ? formattedItems[0].return_date
              : "";

          const row = {
            id: index + 1 || order.id || "",
            order_code: order.order_code || "",
            qrcode: order.qrcode || "",
            company_id: company.company_id || "",
            company_name: company.company_name || "",
            order_status: order.order_status || "",
            order_type: order?.Order_sells
              ? "Order_sells"
              : order?.Order_items
              ? "Order_items"
              : order?.order_pawns
              ? "order_pawns"
              : "order_borrows", // Add this if available in your data
            created_date: order.created_at
              ? moment(order.created_at).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
              : "",
            updated_date: order.updated_at
              ? moment(order.updated_at).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
              : "",
            customer_name: customer.name || "",
            idcard: customer.idcard || "",
            customer_phonenumber: customer.phonenumber || "",
            customer_address: customer.address || "",
            prefix: customer.prefix || "",
            nationality: customer.nationality || "",
            customer_image: customer.image || "",
            picture: [], // Add this if available in your data
            order_items: formattedItems,
            total_price: total_price,
            lenting_amount: lenting_amount,
            return_date: return_date,
            length_type: formattedItems.length,
            product_type: formattedItems.product_type, // Add this if available in your data
          };
          orders.push(row);
          // rows.push(row);
        });
        rows.push({
          id: customer.id || "",
          customer_id: customer.id,
          customer_name: customer.name || "",
          idcard: customer.idcard || "",
          customer_phonenumber: customer.phonenumber || "",
          customer_address: customer.address || "",
          customer_image: customer.image || "",
          prefix: customer.prefix || "",
          nationality: customer.nationality || "",
          company_id: company.company_id || "",
          company_name: company.company_name || "",
          order_items: orders,
        });
      });
    }

    // console.log("Formatted Rows:", rows);
    return rows;
  }, [fetchData]);

  return formattedData;
};

export default useProductData;
